import { useEffect, useState } from "react"
import toast, { Toaster } from 'react-hot-toast'
import { translations } from '../../../configs/translations'
import { EventService } from '../../../services/EventService'
import PlayerService from '../../../services/PlayerService'
import { useStore } from '../../../store/store'
import { KodLeaderboard } from "./KodLeaderboard/KodLeaderboard"
import { KodEventLeaderboardDto } from './KodLeaderboard/KodLeaderboard.types'

export const KingOfTheDrift = ({ eventSource }: { eventSource: EventSource }) => {
	const language = useStore(state => state.language)
	const t = translations[language]
	const [showLeaderboard, setShowLeaderboard] = useState(false)
	const [leaderboard, setLeaderboard] = useState<KodEventLeaderboardDto | null>(null)

	useEffect(() => {

		eventSource.addEventListener('EVENT_SHOW_LEADERBOARD', (e) => {
			EventService.getLeaderboard()
				.then((response) => {
					if (response) {
						setLeaderboard(response)
						setShowLeaderboard(true)
						PlayerService.showCursor()
					}
				})
				.catch((error) => {
					toast.error(
						error?.response?.data && t[error.response.data as keyof typeof t]
							? t[error.response.data as keyof typeof t]
							: t.error_unknown,
						{ className: 'notification-error' }
					)
				})
		})

		return () => {
			eventSource.removeEventListener('EVENT_SHOW_LEADERBOARD', (e) => { })
		}

	}, [])

	const onClick = () => {
		EventService.setKodContinued()
			.then(() => {
				PlayerService.hideCursor()
				setShowLeaderboard(false)
			})
			.catch((error) => {
				toast.error(
					error?.response?.data && t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})
	}

	return (
		<div>
			{showLeaderboard && (
				<KodLeaderboard
					leaderboard={leaderboard}
					isContinued={false}
					setIsContinued={onClick}
				/>
			)}

			<Toaster position="bottom-center" />
		</div>
	)
}